module.exports = __webpack_public_path__ + "img/idcard-back.7b37231e.png";